module.exports = __webpack_public_path__ + "static/img/035_TO8_1525_og.390560e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/035_TO8_1525_og.jpg
// module id = IhEa
// module chunks = 0